import { useEffect } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { profileCheckStatusAtom, userPreferencesModalOpenAtom } from '~/atoms/userPreferences';
export function useProfileEnforcement() {
    const status = useAtomValue(profileCheckStatusAtom);
    const [isOpen, setOpen] = useAtom(userPreferencesModalOpenAtom);
    useEffect(() => {
        if (status.isLoading || status.isComplete)
            return;
        if (!isOpen)
            setOpen(true);
    }, [status.isLoading, status.isComplete, isOpen, setOpen]);
}
